import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.jpg";

const Header = () => {
  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        .font-header {
          background: linear-gradient(
            135deg,
            rgba(247, 20, 88, 0.8),
            rgba(254, 225, 64, 0.8)
          );
          color: white;
          min-height: 70px;
          padding: 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          z-index: 1000;
          flex-wrap: wrap;
        }

        /* LEFT SIDE */
        .logo-title {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo {
          height: 50px;
          width: 50px;
          border-radius: 50%;
          object-fit: cover;
        }

        .logo-title h2 {
          margin: 0;
          font-size: 24px;
          font-weight: 700;
        }

        /* RIGHT SIDE NAV */
        .nav-links {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .nav-links a {
          color: white;
          text-decoration: none;
          font-weight: 500;
          font-size: 16px;
          transition: 0.3s;
        }

        .nav-links a:hover {
          text-decoration: underline;
          opacity: 0.9;
        }

        /* =========================
           TABLET RESPONSIVE
        ========================= */
        @media (max-width: 992px) {
          .font-header {
            padding: 12px 16px;
          }

          .logo-title h2 {
            font-size: 20px;
          }

          .nav-links {
            gap: 14px;
          }

          .nav-links a {
            font-size: 15px;
          }
        }

        /* =========================
           MOBILE RESPONSIVE
        ========================= */
        @media (max-width: 768px) {
          .font-header {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 15px;
            text-align: center;
          }

          .logo-title {
            justify-content: center;
            flex-direction: column;
            gap: 8px;
          }

          .logo {
            width: 60px;
            height: 60px;
          }

          .logo-title h2 {
            font-size: 18px;
            line-height: 1.3;
          }

          .nav-links {
            width: 100%;
            justify-content: center;
            gap: 12px;
          }

          .nav-links a {
            font-size: 14px;
          }
        }

        /* =========================
           SMALL MOBILE
        ========================= */
        @media (max-width: 480px) {
          .logo-title h2 {
            font-size: 16px;
          }

          .nav-links {
            gap: 10px;
          }

          .nav-links a {
            font-size: 13px;
          }

          .logo {
            width: 55px;
            height: 55px;
          }
        }
      `}</style>

      <div className="font-header">
        <div className="logo-title">
          <img src={Logo} alt="logo" className="logo" />
          <h2>Sharada Hill Modern School</h2>
        </div>

        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/notices">Notices</Link>
          <Link to="/login">Login</Link>

        </div>
      </div>
    </>
  );
};

export default Header;